import checkColor from "./colors/check-color";

/**
 * Get resolution from cluster string
 * @param {String} input
 * @param {Number} [level]
 * @param {String} [name] Possible option name
 * @return {ResolutionClusterProps}
 */
const getClusterResolutions = (input, level = 0, name = "") => {
  const map = new Map();

  if (input.startsWith("[") && input.endsWith("]")) {
    if (input.includes("✦")) {
      const sliced = input.slice(1, -1);
      const items = sliced.split("✦");

      for (const item of items) {
        const split = item.split("▹");

        /** Has resolution name */
        if (split[1]) {
          /** Has resolution name */
          map.set(split[0], checkColor(split[1], level, name));
        } else {
          /** All resolutions */
          map.set("all", checkColor(split[0], level, name));
        }
      }
    } else {
      map.set("all", checkColor(input.slice(1,-1), level, name));
    }
  } else {
    /** No resolution */
    map.set("all", checkColor(input, level, name));
  }
  return map;
};

export default getClusterResolutions;
